// extracted by mini-css-extract-plugin
export var colorSquare = "_no-0";
export var container = "_no-h";
export var danger = "_no-5";
export var lightPink = "_no-8";
export var neutralBlue = "_no-7";
export var neutralYellow = "_no-6";
export var normal = "_no-1";
export var primary = "_no-2";
export var primaryLight = "_no-3";
export var selected = "_no-i";
export var solidBlack = "_no-g";
export var solidGreen = "_no-b";
export var solidLightBlue = "_no-d";
export var solidNavy = "_no-c";
export var solidOrange = "_no-f";
export var solidPink = "_no-e";
export var solidRed = "_no-9";
export var solidYellow = "_no-a";
export var success = "_no-4";